import { render, staticRenderFns } from "./InstallmentInformationIndex.vue?vue&type=template&id=53bd495a&scoped=true"
import script from "./InstallmentInformationIndex.vue?vue&type=script&lang=js"
export * from "./InstallmentInformationIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53bd495a",
  null
  
)

export default component.exports